import { z } from 'zod';
/**
 * The smelter (ADR 0018). The client names the piece to fuse; the server
 * picks the five instances, knows the price, and makes the new one.
 */
export const FuseItemMessageSchema = z.object({ templateId: z.string().min(1).max(64) });
/** To the owner alone, after the fusion; the new inventory, gold included, follows. */
export const FuseResultSchema = z.object({
    from: z.string().min(1),
    to: z.string().min(1),
    gold: z.number().int().min(0),
});
export const FUSE_REFUSALS = [
    'invalid',
    'not-fusable',
    'missing-pieces',
    'missing-gold',
    'too-far',
];
export const FuseRejectedSchema = z.object({ reason: z.enum(FUSE_REFUSALS) });
//# sourceMappingURL=fusion.js.map